<template>
    <div class="container">
        <header class="f-bcf ">
            <div class="nameBox f-dfsb">
                <div>
                    <img class="back" v-show="isback" src="../assets/jxwx/arr_02.png" alt="" @click="backward()">
                    <span class="depName">{{data.group_name}}</span>
                </div>
                <span class="docName">{{data.groupleader_name | nameP}}</span>
            </div>

        </header>
        <div class="tabBox">
            <van-tabs class="tabWrap">
                <van-tab title="绩效">
                    <ul class="performanceBox f-dfsb">
                        <li class="f-tal">
                            <div class="tt f-fs2 f-cl1">本月绩效累计(元)</div>
                            <div class="f-fs8">{{data.totalMonthFee | moneyP}}</div>
                        </li>
                        <li class="f-tar">
                            <div class="tt f-fs2 f-cl1">昨日绩效(元)</div>
                            <div class="f-cl2 f-fs8">{{data.totalFee | moneyP}}</div>
                        </li>
                    </ul>
                    <van-tabs v-model="active" class="f-mgb">
                        <van-tab title="本组当前排名">
                            <div class="rankBox">
                                <ve-histogram :extend="chartExtend" :data="chartData" height="123px" :tooltip-visible="false" :legend-visible="false"></ve-histogram>
                            </div>
                        </van-tab>
                        <van-tab title="本组历史排名">
                            <div class="rankBox">
                                <ul class="rangeList">
                                    <li>
                                        <div class="date">日期</div>
                                        <div class="range">排名</div>
                                    </li>
                                    <li v-for="item in data.monthHistory" :key="item.id">
                                        <div class="date">{{item.month}}</div>
                                        <div class="range">{{item.sort}}</div>
                                    </li>
                                </ul>
                            </div>
                        </van-tab>
                    </van-tabs>

                    <section class="f-bcf f-mgb">
                        <van-tabs v-model="tabName" @click="handleClick">
                            <van-tab v-for="item in tabList" :key="item.id" :title=item.tt :name=item.tt></van-tab>
                        </van-tabs>
                        <ve-line :extend="chartExtend2" :data="chartData2" height="155px" :legend-visible="false"></ve-line>
                        <ul class="timeList">
                            <li v-for="(item,index) in timeList" :key="item.id" :class="{active:timeActive == index}" @click="timeChoose(index)">{{item.time}}</li>
                        </ul>
                    </section>

                    <van-tabs v-model="active2" class="detailsTab f-mgb">
                        <van-tab title="计费项明细">
                            <ul class="m-detailsList f-bcf">
                                <li>
                                    <div class="itemName">绩效项</div>
                                    <div class="cumMonth">本月累计</div>
                                    <div class="yesPer">
                                        <div>昨日绩效</div>
                                    </div>
                                </li>
                                <li v-for="item in data.feeDetails" :key="item.id">
                                    <div class="itemName">{{item.name }}</div>
                                    <div class="cumMonth">{{item.month | moneyP}}</div>
                                    <div class="yesPer">
                                        <div class="f-cl2">{{item.today | moneyP}}</div>
                                    </div>
                                    <!-- <i class="arrow"></i> -->
                                </li>
                            </ul>
                        </van-tab>
                        <van-tab title="组员明细">
                            <ul class="m-detailsList f-bcf">
                                <li>
                                    <div class="itemName">&ensp;姓名</div>
                                    <div class="cumMonth">本月累计</div>
                                    <div class="yesPer">
                                        <div>昨日绩效</div>
                                    </div>
                                </li>
                                <li v-for="item in data.memberList" :key="item.id" @click="toChargeDetails(item)">
                                    <div class="itemName">{{item.name | nameP}}</div>
                                    <div class="cumMonth">{{item.MonthFee | moneyP}}</div>
                                    <div class="yesPer">
                                        <div class="f-cl2">{{item.todayMoney | moneyP}}</div>
                                    </div>
                                </li>
                            </ul>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab title="医保">
                    <header class="g-hd f-bcf">
                        <div class="f-dfsb">
                            <span class="time">本日总收入(元)</span>
                            <span class="daytotal">{{data2.daytotal | moneyP}}</span>
                        </div>
                    </header>
                    <div class="detailList">
                        <!-- <div class="f-dfsb">
                            <span class="name">{{data2.clinicmergedesc}}</span>
                            <span class="tt">本日总收入(元)</span>
                        </div> -->

                        <div class="drop_down">
                            <transition name="draw">
                                <div class="listBox" v-if="show">
                                    <ul class="drop_list">
                                        <li class="f-dfa">
                                            <div>
                                                <p class="num">{{data2.monthtotal | moneyP}}</p>
                                                <p class="tt">月收入累计</p>
                                            </div>
                                            <div>
                                                <p class="num">{{data2.monthdrugs | moneyP}}</p>
                                                <p class="tt">月药品累计</p>
                                            </div>
                                            <div>
                                                <p class="num">{{data2.monthdrugsper | moneyP}}</p>
                                                <p class="tt">月药占比</p>
                                            </div>
                                        </li>
                                        <li class="f-dfa f-mb0">
                                            <div>
                                                <p class="num">{{data2.medicalincome | moneyP}}</p>
                                                <p class="tt">医疗</p>
                                            </div>
                                            <div>
                                                <p class="num">{{data2.drugsincome | moneyP}}</p>
                                                <p class="tt">药品</p>
                                            </div>
                                            <div>
                                                <p class="num">{{data2.drugsper | moneyP}}%</p>
                                                <p class="tt">药占比</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </transition>
                        </div>
                        <div class="imgBox" v-on:click="show = !show">
                            <img class="dropImg" v-if="show" src="../assets/jxwx/report/drop2.png" alt="">
                            <img class="dropImg" v-else src="../assets/jxwx/report/drop.png" alt="">
                        </div>
                    </div>
                    <div class="control_box">
                        <ul>
                            <li class="tt">本日医保收入合计（元）</li>
                            <li class="num">{{data2.insuredincome | moneyP}}</li>
                            <li class="per">
                                占比 {{data2.insuredper | moneyP}}%
                            </li>
                        </ul>
                        <ul>
                            <li class="tt">本日非医保收入合计（元）</li>
                            <li class="num">{{data2.uninsuredincome | moneyP}}</li>
                            <li class="per">
                                占比 {{data2.uninsuredper | moneyP}}%
                            </li>
                        </ul>
                    </div>
                    <div class="u-card cardBox">
                        <div class="bd">
                            <div class="m-hos" v-if="data2.towninhosquota == 0">
                                <header class="f-df">
                                    <img src="../assets/jxwx/report/point.png" alt=""> 住院-城镇
                                </header>
                                <div class="progress">
                                    <div class="progress_bar" :class="{'progress_bar2':data2.towninhosprop <= 80,'progress_bar3':data2.towninhosprop >= 100}" :style="{width: data2.towninhosprop + '%'}">
                                    </div>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次占比</span>
                                    <span class="mark nm">--</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次额度</span>
                                    <span class="nm">--</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次</span>
                                    <span class="nm">{{data2.towninhosavg | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次剩余</span>
                                    <span class="mark nm">--</span>
                                </div>
                            </div>
                            <div class="m-hos" v-else>
                                <header class="f-df">
                                    <img src="../assets/jxwx/report/point.png" alt=""> 住院-城镇
                                </header>
                                <div class="progress">
                                    <div class="progress_bar" :class="{'progress_bar2':data2.towninhosprop <= 80,'progress_bar3':data2.towninhosprop >= 100}" :style="{width: data2.towninhosprop + '%'}">
                                    </div>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次占比</span>
                                    <span class="mark nm">{{data2.towninhosprop | moneyP}}%</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次额度</span>
                                    <span class="nm">{{data2.towninhosquota | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次</span>
                                    <span class="nm">{{data2.towninhosavg | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次剩余</span>
                                    <span class="mark nm">{{data2.towninhossurplus | moneyP}}</span>
                                </div>
                            </div>
                            <div class="m-hos" v-if="data2.resinhosquota == 0">
                                <header class="f-df">
                                    <img src="../assets/jxwx/report/point.png" alt=""> 住院-居民
                                </header>
                                <div class="progress">
                                    <div class="progress_bar" :class="{'progress_bar2':data2.resinhosprop <= 80,'progress_bar3':data2.resinhosprop >= 100}" :style="{width: data2.resinhosprop + '%'}">
                                    </div>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次占比</span>
                                    <span class="mark nm">--</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次额度</span>
                                    <span class="nm">--</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次</span>
                                    <span class="nm">{{data2.resinhosavg | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次剩余</span>
                                    <span class="mark nm">--</span>
                                </div>
                            </div>
                            <div class="m-hos" v-else>
                                <header class="f-df">
                                    <img src="../assets/jxwx/report/point.png" alt=""> 住院-居民
                                </header>
                                <div class="progress">
                                    <div class="progress_bar" :class="{'progress_bar2':data2.resinhosprop <= 80,'progress_bar3':data2.resinhosprop >= 100}" :style="{width: data2.resinhosprop + '%'}">
                                    </div>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次占比</span>
                                    <span class="mark nm">{{data2.resinhosprop | moneyP}}%</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次额度</span>
                                    <span class="nm">{{data2.resinhosquota | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次</span>
                                    <span class="nm">{{data2.resinhosavg | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次剩余</span>
                                    <span class="mark nm">{{data2.resinhossurplus | moneyP}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="line"></div>
                        <div class="bd">
                            <div class="m-hos" v-if="data2.townouthosquota == 0">
                                <header class="f-df">
                                    <img src="../assets/jxwx/report/point.png" alt=""> 门急诊-城镇
                                </header>
                                <div class="progress">
                                    <div class="progress_bar" :class="{'progress_bar2':data2.townouthosprop <= 80,'progress_bar3':data2.townouthosprop >= 100}" :style="{width: data2.townouthosprop + '%'}">
                                    </div>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次占比</span>
                                    <span class="mark nm">--</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次额度</span>
                                    <span class="nm">--</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次</span>
                                    <span class="nm">{{data2.townouthosavg | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次剩余</span>
                                    <span class="mark nm">--</span>
                                </div>
                            </div>
                            <div class="m-hos" v-else>
                                <header class="f-df">
                                    <img src="../assets/jxwx/report/point.png" alt=""> 门急诊-城镇
                                </header>
                                <div class="progress">
                                    <div class="progress_bar" :class="{'progress_bar2':data2.townouthosprop <= 80,'progress_bar3':data2.townouthosprop >= 100}" :style="{width: data2.townouthosprop + '%'}">
                                    </div>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次占比</span>
                                    <span class="mark nm">{{data2.townouthosprop | moneyP}}%</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次额度</span>
                                    <span class="nm">{{data2.townouthosquota | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次</span>
                                    <span class="nm">{{data2.townouthosavg | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次剩余</span>
                                    <span class="mark nm">{{data2.townouthossurplus | moneyP}}</span>
                                </div>
                            </div>
                            <div class="m-hos" v-if="data2.resouthosquota == 0">
                                <header class="f-df">
                                    <img src="../assets/jxwx/report/point.png" alt=""> 门急诊-居民
                                </header>
                                <div class="progress">
                                    <div class="progress_bar" :class="{'progress_bar2':data2.resouthosprop <= 80,'progress_bar3':data2.resouthosprop >= 100}" :style="{width: data2.resouthosprop + '%'}">
                                    </div>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次占比</span>
                                    <span class="mark nm">--</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次额度</span>
                                    <span class="nm">--</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次</span>
                                    <span class="nm">{{data2.resouthosavg | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次剩余</span>
                                    <span class="mark nm">--</span>
                                </div>
                            </div>
                            <div class="m-hos" v-else>
                                <header class="f-df">
                                    <img src="../assets/jxwx/report/point.png" alt=""> 门急诊-居民
                                </header>
                                <div class="progress">
                                    <div class="progress_bar" :class="{'progress_bar2':data2.resouthosprop <= 80,'progress_bar3':data2.resouthosprop >= 100}" :style="{width: data2.resouthosprop + '%'}">
                                    </div>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次占比</span>
                                    <span class="mark nm">{{data2.resouthosprop | moneyP}}%</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次额度</span>
                                    <span class="nm">{{data2.resouthosquota | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">当前医保均次</span>
                                    <span class="nm">{{data2.resouthosavg | moneyP}}</span>
                                </div>
                                <div class="entry">
                                    <span class="ctt">医保均次剩余</span>
                                    <span class="mark nm">{{data2.resouthossurplus | moneyP}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="个人">
                    <div class="personBox" v-for="item in data3" :key="item.id">

                        <div class="u-card cardBox">
                            <div class="line lineName">
                                <img src="../assets/jxwx/report/icon_04.png" alt="">
                                {{item.doctorName}}
                            </div>
                            <div class="bd">
                                <div class="m-hos" >
                                    <header class="f-df">
                                        <img src="../assets/jxwx/report/point.png" alt=""> 住院-城镇
                                    </header>
                                    <div class="progress">
                                        <div class="progress_bar" :class="{'progress_bar2':item.medgroupinper <= 80,'progress_bar3':item.medgroupinper >= 100}" :style="{width: item.medgroupinper + '%'}">
                                        </div>
                                    </div>
                                    <div class="entry">
                                        <div>
                                            <span class="ctt">占比</span>
                                            <span class="mark nm">{{item.medgroupinper | moneyP}}%</span>
                                        </div>
                                        <div>
                                            <span class="ctt">均次</span>
                                            <span class="nm">{{item.medgroupin | moneyP}}</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="m-hos" >
                                    <header class="f-df">
                                        <img src="../assets/jxwx/report/point.png" alt=""> 住院-居民
                                    </header>
                                    <div class="progress">
                                        <div class="progress_bar" :class="{'progress_bar2':item.insugroupinper <= 80,'progress_bar3':item.insugroupinper >= 100}" :style="{width: item.insugroupinper + '%'}">
                                        </div>
                                    </div>
                                    <div class="entry">
                                        <div>
                                            <span class="ctt">占比</span>
                                            <span class="mark nm">{{item.insugroupinper | moneyP}}%</span>
                                        </div>
                                        <div>
                                            <span class="ctt">均次</span>
                                            <span class="nm">{{item.insugroupin | moneyP}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="bd">
                                
                                <div class="m-hos" >
                                    <header class="f-df">
                                        <img src="../assets/jxwx/report/point.png" alt=""> 门急诊-城镇
                                    </header>
                                    <div class="progress">
                                        <div class="progress_bar" :class="{'progress_bar2':item.medgroupper <= 80,'progress_bar3':item.medgroupper >= 100}" :style="{width: item.medgroupper + '%'}">
                                        </div>
                                    </div>
                                    <div class="entry">
                                        <div>
                                            <span class="ctt">占比</span>
                                            <span class="mark nm">{{item.medgroupper | moneyP}}%</span>
                                        </div>
                                        <div>
                                            <span class="ctt">均次</span>
                                            <span class="nm">{{item.medgroup | moneyP}}</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="m-hos" >
                                    <header class="f-df">
                                        <img src="../assets/jxwx/report/point.png" alt=""> 门急诊-居民
                                    </header>
                                    <div class="progress">
                                        <div class="progress_bar" :class="{'progress_bar2':item.insugroupper <= 80,'progress_bar3':item.insugroupper >= 100}" :style="{width: item.insugroupper + '%'}">
                                        </div>
                                    </div>
                                    <div class="entry">
                                        <div>
                                            <span class="ctt">占比</span>
                                            <span class="mark nm">{{item.insugroupper | moneyP}}%</span>
                                        </div>
                                        <div>
                                            <span class="ctt">均次</span>
                                            <span class="nm">{{item.insugroup | moneyP}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>

        <!-- <div class="u-detailsRecord" @click="viewRecords">
            查看绩效记录
            <img src="../assets/jxwx/arr_03.png" alt="">
        </div> -->
    </div>
</template>

<script>
import api from "@/axios/api";
import { mapGetters, mapActions } from "vuex";
export default {
    computed: {
        ...mapGetters(["token"])
    },
    watch: {
        token: {
            immediate: true,
            handler: function(val) {
                if (val) {
                    this.getResultByGroup(this.groupId, this.date);
                    this.getDailyCountData(this.date, this.groupId);
                    this.getDoctorData(this.date, this.groupId);
                }
            }
        }
    },
    data() {
        return {
            active: 0,
            active2: 0,
            tabName: "全部",
            timeActive: 0,
            chartExtend: {
                tooltip: {
                    show: false
                },
                grid: {
                    x: 30,
                    y: 20,
                    x2: 30,
                    y2: 15
                },
                series: {
                    stack: "排名",
                    label: {
                        color: "#5EBDFB",
                        show: true,
                        position: "top",
                        formatter: function(params) {
                            if (
                                params.dataIndex == 0 &&
                                params.seriesName == "Sort"
                            ) {
                                return "NO." + params.value;
                            } else {
                                return "";
                            }
                        }
                    },
                    itemStyle: {
                        //通常情况下：
                        normal: {
                            //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                            color: function(params) {
                                if (params.dataIndex == 0) {
                                    return "rgba(107,197,255,1)";
                                } else {
                                    return "rgba(166,166,166,.3)";
                                }
                            }
                        }
                    },
                    barWidth: 15
                },
                xAxis: {
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#dedede"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    }
                },
                yAxis: {
                    axisTick: {
                        //y轴刻度线
                        show: false
                    },
                    axisLabel: {
                        //y轴刻度线
                        show: false
                    },
                    splitLine: {
                        //网格线
                        show: false
                    }
                }
            },
            chartExtend2: {
                grid: {
                    x: 20,
                    y: 20,
                    x2: 20,
                    y2: 5
                },
                series: {
                    symbol: "none",
                    lineStyle: {
                        normal: {
                            color: "#0898EA"
                        }
                    }
                },
                xAxis: {
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#dedede"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    }
                },
                yAxis: {
                    axisTick: {
                        //y轴刻度线
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    },
                    splitLine: {
                        //网格线
                    }
                }
            },

            chartData: {
                columns: ["group_name", "MONEY", "Sort"],
                rows: []
            },
            chartData2: {
                columns: ["日期", "绩效"],
                rows: []
            },
            tabList: [
                {
                    tt: "全部"
                },
                {
                    tt: "诊查费"
                },
                {
                    tt: "收住院"
                },
                {
                    tt: "检查开单"
                },
                {
                    tt: "手术费"
                },
                {
                    tt: "检查相关"
                },
                {
                    tt: "单项统计"
                }
            ],
            timeList: [
                {
                    time: "近1月"
                },
                // {
                //     time: "近3月"
                // },
                {
                    time: "近6月"
                },
                {
                    time: "近1年"
                }
            ],
            data: {},
            data2: {},
            data3:[],
            groupId: this.$route.query.groupId,
            date: this.$route.query.date,
            isback: this.$route.query.isback,
            classData: [],
            monthdayList: [],
            sixMonthList: [],
            yearList: [],
            show: false
        };
    },
    filters: {
        nameP: function(value) {
            if (value) {
                return value.split("(")[0];
            }
        }
    },
    // filters: {
    //     moneyP: function(value) {
    //         if (value != undefined) {
    //             // var num = Math.round(value*100)/100;
    //             if (value != 0) {
    //                 var value = Math.round(parseFloat(value) * 100) / 100;
    //                 var xsd = value.toString().split(".");
    //                 if (xsd.length == 1) {
    //                     value = value.toString() + ".00";
    //                     var val = value;
    //                 }
    //                 if (xsd.length > 1) {
    //                     if (xsd[1].length < 2) {
    //                         value = value.toString() + "0";
    //                     }
    //                     var val = value;
    //                 }
    //                 var str = val.toString();
    //                 var reg =
    //                     str.indexOf(".") > -1
    //                         ? /(\d)(?=(\d{3})+\.)/g
    //                         : /(\d)(?=(?:\d{3})+$)/g;
    //                 return str.replace(reg, "$1,");
    //             } else {
    //                 return "0.00";
    //             }

    //             // return Number(value.toString().match(/^\d+(?:\.\d{0,2})?/));
    //         }
    //     }
    // },

    methods: {
        handleClick(name) {
            this.classData = [];
            this.lineData(this.tabName);
        },
        timeChoose(index) {
            this.timeActive = index;
            this.classData = [];
            this.lineData(this.tabName);
        },
        lineData(itemName) {
            switch (this.timeActive) {
                case 0:
                    this.monthdayList.forEach(item => {
                        this.itemChoose(itemName, item);
                    });
                    this.chartData2.rows = this.classData;
                    break;
                case 1:
                    this.sixMonthList.forEach(item => {
                        this.itemChoose2(itemName, item);
                    });
                    this.chartData2.rows = this.classData;
                    break;
                case 2:
                    this.yearList.forEach(item => {
                        this.itemChoose2(itemName, item);
                    });
                    this.chartData2.rows = this.classData;
                    break;
            }
        },
        itemChoose(itemName, item) {
            switch (itemName) {
                case "全部":
                    var i = {
                        日期: item.feedate,
                        绩效: item.total
                    };
                    this.classData.push(i);
                    break;
                case "诊查费":
                    var i = {
                        日期: item.feedate,
                        绩效: item.examinationFee
                    };
                    this.classData.push(i);
                    break;
                case "收住院":
                    var i = {
                        日期: item.feedate,
                        绩效: item.inpatientNumFee
                    };
                    this.classData.push(i);
                    break;
                case "检查开单":
                    var i = {
                        日期: item.feedate,
                        绩效: item.checkorderFee
                    };
                    this.classData.push(i);
                    break;
                case "手术费":
                    var i = {
                        日期: item.feedate,
                        绩效: item.operationFee
                    };
                    this.classData.push(i);
                    break;
                case "检查相关":
                    var i = {
                        日期: item.feedate,
                        绩效: item.checkrelatedFee
                    };
                    this.classData.push(i);
                    break;
                case "单项统计":
                    var i = {
                        日期: item.feedate,
                        绩效: item.singleFee
                    };
                    this.classData.push(i);
                    break;
            }
        },
        itemChoose2(itemName, item) {
            switch (itemName) {
                case "全部":
                    var i = {
                        日期: item.month,
                        绩效: item.total
                    };
                    this.classData.push(i);
                    break;
                case "诊查费":
                    var i = {
                        日期: item.month,
                        绩效: item.examinationFee
                    };
                    this.classData.push(i);
                    break;
                case "收住院":
                    var i = {
                        日期: item.month,
                        绩效: item.inpatientNumFee
                    };
                    this.classData.push(i);
                    break;
                case "检查开单":
                    var i = {
                        日期: item.month,
                        绩效: item.checkorderFee
                    };
                    this.classData.push(i);
                    break;
                case "手术费":
                    var i = {
                        日期: item.month,
                        绩效: item.operationFee
                    };
                    this.classData.push(i);
                    break;
                case "检查相关":
                    var i = {
                        日期: item.month,
                        绩效: item.checkrelatedFee
                    };
                    this.classData.push(i);
                    break;
                case "单项统计":
                    var i = {
                        日期: item.month,
                        绩效: item.singleFee
                    };
                    this.classData.push(i);
                    break;
            }
        },
        toChargeDetails(item) {
            if (item.name != "主任分配绩效") {
                this.$router.replace({
                    path: "/jxwx/chargeDetails",
                    query: {
                        data: item,
                        date: this.date
                    }
                });
            } else {
                return;
            }
        },
        viewRecords() {
            this.$router.replace({
                path: "/jxwx/chargeRecord",
                query: {}
            });
        },
        getResultByGroup(groupId, time) {
            let par = {
                groupId: groupId,
                taday: time
            };
            api.getResultByGroup(par).then(res => {
                this.data = res.result;
                let monthSort = res.result.monthSort;
                monthSort.forEach(item => {
                    let len = item.group_name.length;
                    item.group_name = item.group_name.substring(len - 1, len);
                });

                monthSort
                    .sort((a, b) => a.group_name - b.group_name)
                    .forEach(item => {
                        if (item.group_id == this.groupId) {
                            item.group_name = "本组";
                        } else {
                            item.group_name = "组" + item.group_name;
                        }
                    });

                for (var i = 0; i < monthSort.length; i++) {
                    if (monthSort[i].group_name === "本组") {
                        var key = monthSort[i];
                        monthSort.splice(i, 1);
                        break;
                    }
                }
                monthSort.unshift(key);
                this.chartData.rows = monthSort;

                this.monthdayList = this.data.curveDetail.monthdayList.reverse();
                this.sixMonthList = this.data.curveDetail.sixMonthList.reverse();
                this.yearList = this.data.curveDetail.yearList.reverse();
                this.lineData(this.tabName);
            });
        },
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        },
        // getQueryVariable(variable) {
        //     var query = window.location.search.substring(1);
        //     var vars = query.split("&");
        //     for (var i = 0; i < vars.length; i++) {
        //         var pair = vars[i].split("=");
        //         if (pair[0] == variable) {
        //             return pair[1];
        //         }
        //     }
        //     return false;
        // }

        getDailyCountData(time, id) {
            let params = {
                date: time,
                depId: "",
                deptMentId: id
            };
            api.getDailyCountData(params).then(res => {
                this.data2 = res[0].medicalEntity[0];
            });
        },
        getDoctorData(time, id) {
            let params = {
                date: time,
                groupId: id,
            };
            api.getDoctorData(params).then(res => {
                this.data3 = res;
            });
        }
    },
    mounted() {
        // this.getResultByGroup(this.groupId, this.date);
        // this.getDailyCountData(this.date, this.groupId);
        // this.getDoctorData(this.date, this.groupId);
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.container {
    margin-bottom: 60px;
}
.nameBox {
    .back {
        width: 2vw;
        margin-right: 2.6vw;
    }
    margin: 0 4.8vw;
    height: 12.8vw;
    // border-bottom: 1px solid #dedede;
    .depName {
        font-size: 18px;
    }
    .docName {
        font-size: 13px;
        color: #a6a6a6;
    }
}
.performanceBox {
    margin: 0 4.8vw;
    padding: 3.2vw 0 1.8vw 0;
    li {
        padding: 1.3vw 0;
        .tt {
            margin-bottom: 2.6vw;
        }
    }
}


.tabBox {
    /deep/.tabWrap {
        & > .van-tabs__wrap {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            border-top: 1px solid #dedede;
            border-bottom: none;
            z-index: 999;
            .van-tab--active {
                background: #e5323b;
                color: #fff;
            }
            .van-tabs__line {
                height: 0;
            }
        }
    }
}
.van-tabs {
    /deep/.van-tabs__wrap {
        border-bottom: 1px solid #dedede;
    }
    /deep/.van-tab--active {
        color: #e5323b;
    }
    /deep/.van-tabs__line {
        width: 10.4vw !important;
    }
    .rankBox {
        // height: 32.6vw;
        background-color: #fff;
        .rangeList {
            li {
                display: flex;
                align-items: center;
                height: 10.6vw;
                div {
                    flex: 1;
                    text-align: center;
                    font-size: 14px;
                }
                .date {
                    color: #a6a6a6;
                }
            }
            li:first-child {
                font-size: 13px;
                color: #a6a6a6;
                background-color: #fafcff;
                border-bottom: 1px solid #dedede;
            }
        }
    }
}
.timeList {
    display: flex;
    background-color: #fafcff;
    height: 9.2vw;
    font-size: 13px;
    color: #a6a6a6;
    li {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        border-top: 1px solid #dedede;
    }
    li.active {
        color: #2c2c2c;
        background-color: #fff;
        border-top: 1px solid #fff;
        border-right: 1px solid #dedede;
        border-left: 1px solid #dedede;
    }
    li:first-child.active {
        border-left: none;
    }
    .customizeBtn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 14.6vw;
        height: 6.4vw;
        line-height: 1;
        border: 1px solid #0897ea;
        border-radius: 6px;
        color: #0897ea;
        box-sizing: border-box;
    }
}
.detailsTab {
    /deep/.van-tab {
        font-size: 16px;
    }
}

.m-detailsList {
    li {
        position: relative;
        display: flex;
        align-items: center;
        height: 14.5vw;
        margin: 0 4vw;
        font-size: 15px;
        border-bottom: 1px solid #dedede;
        div {
            flex: 1;
            text-align: center;
        }
        .itemName {
            text-align: left;
        }
        .yesPer {
            text-align: right;
            div {
                display: inline-block;
                width: 20vw;
            }
        }
        i {
            position: absolute;
            right: 0;
            display: inline-block;
            width: 2vw;
            height: 3.6vw;
            background: url(../assets/jxwx/arr_03.png) no-repeat;
            background-size: 100% 100%;
        }
    }
    li:first-child {
        margin: 0;
        height: 10.9vw;
        padding: 0 4vw;
        background-color: #fafcff;
        font-size: 13px;
        color: #a6a6a6;
        border-bottom: 1px solid #d4e5ff;
        .itemName {
            padding-left: 2px;
        }
    }
    li:last-child {
        border-bottom: none;
    }
}

.g-hd {
    display: flex;
    align-items: center;
    height: 13.3vw;
    padding: 0 3.3vw;
    color: #fff;
    background: #5584ff;
    .f-dfsb {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .back {
        width: 2vw;
        font-size: 16px;
        margin-right: 2.6vw;
    }
    .time {
        font-size: 12px;
    }
    .daytotal {
        font-size: 21px;
    }
    .tt {
        margin-left: 4vw;
    }
}
.detailList {
    padding: 0 3.3vw;
    color: #fff;
    background: #5584ff;
    .name {
        margin-left: 0.3vw;
        font-size: 16px;
    }
    .tt {
        margin-right: 1.7vw;
        font-size: 12px;
        color: #a6bdfa;
    }
    .drop_down {
        .listBox {
            overflow: hidden;
        }
        .drop_list {
            padding: 4vw 0 0 0;
            li {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 3.2vw;
                border: 1px solid #2e68ff;
                border-radius: 6px;
                div {
                    flex: 1;
                    text-align: center;
                    p:first-child {
                        margin: 2vw 0 1vw 0;
                        font-size: 13px;
                    }
                    p:last-child {
                        margin: 1vw 0 2vw 0;
                        font-size: 12px;
                    }
                }
            }
            .f-mb0 {
                margin: 0;
            }
        }
    }
}
.imgBox {
    padding: 2vw 0;
    text-align: center;
    .dropImg {
        width: 2vw;
        height: 1vw;
    }
}
.control_box {
    display: flex;
    margin: 3.7333vw 2.5333vw;
    background: #f5e6d0;
    border-radius: 6px;
}
.control_box2 {
    margin: 0;
    background: #91c619;
    border-radius: 0;
}
.control_box > ul {
    flex: 1;
    text-align: center;
    padding-bottom: 3.0667vw;
}
.control_box > ul > .tt {
    padding: 3.4667vw 0 2.6667vw 0;
    font-size: 12px;
    color: #afafaf;
}
.control_box2 > ul > .tt {
    padding: 4.2667vw 0 3.2vw 0;
    font-size: 12px;
    color: #def0b6;
}
.control_box > ul > .num {
    padding: 0 0 2.1333vw 0;
    font-size: 21px;
    color: #f56b18;
}
.control_box2 > ul > .num {
    padding: 0 0 1.7333vw 0;
    color: #fff;
}
.control_box > ul > .per {
    width: 20.9333vw;
    margin: 0 auto;
    padding: 0.8vw 0;
    border: 1px solid rgba(196, 196, 196, 1);
    border-radius: 5px;
    font-size: 10px;
    color: #f56b18;
}
.control_box2 > ul > .per {
    width: 19.0667vw;
    margin: 0 auto;
    padding: 1.6vw 0;
    border: 1px solid #d9edaf;
    border-radius: 5px;
    font-size: 13px;
    color: #fff;
}

.line {
    margin: 0 -4vw;
    border-bottom: 1px solid #d4d4d4;
}
.lineName{
    display: flex;
    align-items: center;
    margin: 0;
    padding: 2vw;

    img{
        width: 4vw;
        margin-right: 1.6vw;
    }
}
.u-card {
    margin: 2.6vw 4vw 0 4vw;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
    // border-radius: 6px;
}
.cardBox {
    .hd {
        display: flex;
        font-size: 13px;
        justify-content: space-between;
        align-items: center;
        height: 12vw;
        padding: 0 4vw;
        border-bottom: 1px solid #dedede;
        .icon {
            width: 4vw;
        }
        .tt {
            display: flex;
            align-items: center;
            img {
                margin-right: 1.6vw;
            }
        }
        .arr {
            width: 1.3vw;
        }
    }
    .bd {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 2vw 0 1.4vw 0;
        .m-hos {
            width: 50%;
            padding: 0 2vw;
            box-sizing: border-box;
            .f-df {
                display: flex;
                align-items: center;
            }
        }
        // .m-hos2 {
        //     width: 42vw;
        //     padding: 0 ;
        // }
        .m-hos header {
            margin-bottom: 3.4667vw;
            font-size: 14px;
            color: #4c4c4c;
        }
        .m-hos header img {
            width: 1.3333vw;
            margin-right: 1.3333vw;
        }
        .m-hos .progress {
            width: 100%;
            height: 2.1333vw;
            margin-bottom: 2.6667vw;
            border-radius: 1.0667vw;
            background-color: #efefef;
            overflow: hidden;
            .progress_bar {
                height: 100%;
                background-color: #fed100;
            }
            .progress_bar2 {
                height: 100%;
                background-color: #91c619;
            }
            .progress_bar3 {
                height: 100%;
                background-color: #f66969;
            }
        }

        .m-hos .entry {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 3.2vw;
            font-size: 12px;
        }
        .m-hos > .entry > .ctt {
            color: #8f8f8f;
        }
        .m-hos > .entry > .nm {
            font-size: 13px;
            color: #282828;
        }
        .m-hos > .entry > .mark {
            color: #f66969;
            // background: #fff;
        }
        .m-hos > .entry > .mark2 {
            color: #91c619;
        }
    }
}
.f-bc {
    padding: 2.6vw 0;
    background: #f7f7f7;
    .u-card {
        margin: 2.6vw 4vw;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
        border-radius: 6px;
    }
    .cardBox {
        .hd {
            display: flex;
            font-size: 13px;
            justify-content: start;
            align-items: center;
            height: 12vw;
            padding: 0 4vw;
            border-bottom: 1px solid #dedede;
            .icon {
                width: 4vw;
            }
            .tt {
                display: flex;
                justify-content: space-between;
                width: 45vw;
                margin: 0 3.2vw 0 1.6vw;
            }
            .arr {
                width: 1.3vw;
            }
        }
        .bd {
            display: flex;
            justify-content: space-between;
            padding: 4vw;
            .tt {
                margin-bottom: 3.2vw;
                font-size: 13px;
                color: #a6a6a6;
            }
            .num {
                font-size: 18px;
            }
        }
    }
}

.draw-enter-active,
.draw-leave-active {
    height: 34.8vw;
    opacity: 1;
    transition: all 0.5s;
}
.draw-enter,
.draw-leave-to {
    height: 0;
    opacity: 0;
}

.personBox {
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/jxwx/teamLeader.vue